"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDTFEngine = void 0;
const SDTFEngine_1 = require("./SDTFEngine");
Object.defineProperty(exports, "SDTFEngine", { enumerable: true, get: function () { return SDTFEngine_1.SDTFEngine; } });
//# sourceMappingURL=index.js.map